import React, { useRef } from 'react';
import DropdownCustomDark from 'views/finance/moduleComponents/DropdownCustomDark';
import DropdownMultiselectDark from 'views/finance/moduleComponents/DropdownMultiselectDark';

const monthsEnum = [
  { value: '01', label: 'Jan' },
  { value: '02', label: 'Feb' },
  { value: '03', label: 'Mar' },
  { value: '04', label: 'Apr' },
  { value: '05', label: 'May' },
  { value: '06', label: 'Jun' },
  { value: '07', label: 'Jul' },
  { value: '08', label: 'Aug' },
  { value: '09', label: 'Sep' },
  { value: '10', label: 'Oct' },
  { value: '11', label: 'Nov' },
  { value: '12', label: 'Dec' },
];

const FilterBudgetBoard = ({
  categories = [],
  selectedType,
  setSelectedType,
  selectedClassL0,
  setSelectedClassL0,
  yearsOpts = [],
  selectedYears,
  setSelectedYears,
  selectedMonths,
  setSelectedMonths,
}) => {
  const categDropdownRef = useRef(null);
  const yearDropdownRef = useRef(null);
  const monthDropdownRef = useRef(null);

  const selectedYearsArray = selectedYears ? String(selectedYears).split('-').filter(Boolean) : [];
  const selectedMonthsArray = selectedMonths ? String(selectedMonths).split('-').filter(Boolean) : [];
  const validYears = (yearsOpts || []).map(String);
  const validMonths = monthsEnum;

  return (
    <div className="bg-gray-600 shadow rounded-xl overflow-hidden mb-2">
      {/* Row 1: dropdown (living/category) + segmented In/Out */}
      <div className="px-2 py-3 flex items-center gap-2">
        <div className="relative flex-1" ref={categDropdownRef} data-portal="categ">
          <DropdownCustomDark
            options={categories}
            selectedValue={selectedClassL0}
            onSelect={setSelectedClassL0}
            placeholder="All"
            width="w-full"
            showRadio={true}
            usePortal={true}
            portalRef={categDropdownRef}
            showAllOption={true}
            allOptionText="All"
            allOptionValue="All"
          />
        </div>
        <div className="bg-gray-500 bg-opacity-30 rounded-full p-0.5 flex">
          {['In', 'Out'].map((type, index) => (
            <button
              key={type}
              onClick={() => setSelectedType(type)}
              className={
                `px-3 py-1 text-xs font-medium transition-all ` +
                (index === 0 ? 'rounded-l-full' : 'rounded-r-full') +
                (selectedType === type
                  ? type === 'In'
                    ? ' text-white bg-green-400'
                    : ' text-white bg-red-400'
                  : ' text-white text-opacity-70 hover:text-opacity-100 hover:bg-gray-500 hover:bg-opacity-20')
              }
            >
              {type}
            </button>
          ))}
        </div>
      </div>

      {/* Row 2: always expanded — Year + Month */}
      <div className="h-12 px-2 flex items-center bg-gray-500 bg-opacity-20">
        <div className="flex items-center gap-2 w-full">
          <div className="flex-1 flex items-center gap-2" ref={yearDropdownRef} data-portal="year">
            <DropdownMultiselectDark
              options={validYears}
              selectedValues={selectedYearsArray}
              onSelect={arr => setSelectedYears(arr.join('-'))}
              placeholder="Select Year"
              width="w-full"
              usePortal={true}
              portalRef={yearDropdownRef}
            />
          </div>
          <div className="flex-1 flex items-center gap-2" ref={monthDropdownRef} data-portal="month">
            <DropdownMultiselectDark
              options={validMonths}
              selectedValues={selectedMonthsArray}
              onSelect={arr => setSelectedMonths(arr.join('-'))}
              placeholder="Select Month"
              width="w-full"
              usePortal={true}
              portalRef={monthDropdownRef}
              gridCols="grid-cols-3"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterBudgetBoard;
